export default __webpack_public_path__ + "static/media/error.eff5d27d.png";